import { useCallback, useEffect, useRef, useState } from 'react'
import { TooltipProviderContextProvider } from './tooltip-context'
import { DEFAULT_DELAY_DURATION } from '../constants'
import PropTypes from 'prop-types'

const TooltipProvider = (props) => {
  const {
    delayDuration = DEFAULT_DELAY_DURATION,
    skipDelayDuration = 300,
    children
  } = props

  const [isOpenDelayed, setIsOpenDelayed] = useState(true)
  const isPointerInTransitRef = useRef(false)
  const skipDelayTimerRef = useRef(0)

  useEffect(() => {
    const skipDelayTimer = skipDelayTimerRef.current
    return () => window.clearTimeout(skipDelayTimer)
  }, [])

  const onOpen = useCallback(() => {
    window.clearTimeout(skipDelayTimerRef.current)
    setIsOpenDelayed(false)
  }, [])

  const onClose = useCallback(() => {
    window.clearTimeout(skipDelayTimerRef.current)
    skipDelayTimerRef.current = window.setTimeout(
      () => setIsOpenDelayed(true),
      skipDelayDuration
    )
  }, [skipDelayDuration])

  const contextValue = {
    onOpen,
    onClose,
    isOpenDelayed,
    delayDuration,
    isPointerInTransitRef
  }

  return (
    <TooltipProviderContextProvider.Provider value={contextValue}>
      {children}
    </TooltipProviderContextProvider.Provider>
  )
}

TooltipProvider.propType = {
  delayDuration: PropTypes.number,
  skipDelayDuration: PropTypes.number
}

export default TooltipProvider
